import { isBroadcastLoginMessage, isBroadcastLogoutMessage } from '@deephaven/jsapi-utils';
import { useCallback } from 'react';
import useBroadcastChannel from "./useBroadcastChannel.js";
export function useBroadcastLoginListener(onLogin, onLogout) {
  var onMessage = useCallback(event => {
    if (isBroadcastLoginMessage(event.data)) {
      onLogin === null || onLogin === void 0 || onLogin(event.data);
    } else if (isBroadcastLogoutMessage(event.data)) {
      onLogout === null || onLogout === void 0 || onLogout(event.data);
    }
  }, [onLogin, onLogout]);
  useBroadcastChannel(onMessage);
}
export default useBroadcastLoginListener;
//# sourceMappingURL=useBroadcastLoginListener.js.map